import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import StanceBody from '../../assets/images/body_full.png';
import withRouter from 'react-router/lib/withRouter';
import Ruler from '../../partials/Ruler';
import { get } from 'Language';

class Stance extends Component {

	state = {
		username: '',
		height: '',
		weight: '',
		shoulder_width: '',
		chest_width: '',
		right_arm: '',
		sizeType: '',
		user_id: ''
	}

	componentWillMount() {
		const { getMeasurements } = this.props;

		getMeasurements();
	}

	componentWillReceiveProps(nextProps) {
		const { measurements } = nextProps;

		this.setState(measurements);
	}

	onChange = ({ target }) => {
		const nextState = {};
        const { name, value } = target;
        nextState[name] = value;
        this.setState(nextState);
	}

	submit = (e) => {
		e.preventDefault();
		const { getStance } = this.props;
		getStance(this.state);
	}

	handleFocus = (e) => {
		const { name } = e.target;
		this.setState({ sizeType: name })
	}

    render(){
		return (
			<div className="panel-custom-wrapper">
				<div className="panel panel-custom">
					<div className="panel-heading">Stance Width</div>
					<form onSubmit={this.submit}>
						<div className="panel-body">
							<div className="row">
								<div className="col-md-4 col-xs-12">
									<div className="form-group">
										<label>{get('STANCE_HEIGHT')}</label>
										<input
											onFocus={this.handleFocus}
											value={this.state.height}
											onChange={this.onChange}
											type="text"
											name="height"
											className="form-control form-custom"
											/>
									</div>
									<div className="form-group">
										<label>{get('STANCE_WEIGHT')}</label>
										<input
											onFocus={this.handleFocus}
											value={this.state.weight}
											onChange={this.onChange}
											type="text"
											name="weight"
											className="form-control form-custom"
											/>
									</div>
									<div className="form-group">
										<label>{get('STANCE_SHOULDER')}</label>
										<input
											onFocus={this.handleFocus}
											value={this.state.shoulder_width}
											onChange={this.onChange}
											type="text"
											name="shoulder_width"
											className="form-control form-custom"
											/>
									</div>
									<div className="form-group">
										<label>{get('STANCE_BODY_WIDTH')}</label>
										<input
											onFocus={this.handleFocus}
											value={this.state.chest_width}
											onChange={this.onChange}
											type="text"
											name="chest_width"
											className="form-control form-custom"
											/>
									</div>
									<div className="form-group">
										<label>{get('STANCE_SHOE_SIZE')}</label>
										<input
											onFocus={this.handleFocus}
											value={this.state.right_arm}
											onChange={this.onChange}
											type="text"
											name="right_arm"
											className="form-control form-custom"
											/>
									</div>
								</div>
								<div className="col-md-8 col-xs-12">
									<div className="body_illustration">
										<div className="body_inner">
											{ this.state.sizeType === "shoulder_width"
												? <Ruler top={103} rows={7} sizeClass="should_width"/>
												: null
											}
											{ this.state.sizeType === "chest_width"
												? <Ruler top={155} rows={9} sizeClass="body_width"/>
												: null
											}
											<img src={StanceBody} alt="presentation"/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="btn-custom text-right panel-footer">
                            <Link className="btn btn-primary" to="/profile">Cancel</Link>&nbsp;
                            <button disabled={ this.props.isWaiting } className="btn btn-success">
                            	{ this.props.isWaiting
                            		? 'Loading...'
                            		: 'Proceed'
                            	}
                            </button>
                        </div>
					</form>
				</div>
			</div>
		)
	}
}

export default withRouter(connect(
	(state, routeParams) => {
		const { measurements } = state.stance;
		const { isWaiting } = state.onWaiting;
		const { params } = routeParams;

		return {
            measurements,
            isWaiting,
            params
		}
	},
	actions
)(Stance))


// WEBPACK FOOTER //
// ./src/stance/containers/Stance.js